import { render } from "./AuditUserDashboard.vue?vue&type=template&id=96a283fe&scoped=true"
import script from "./AuditUserDashboard.vue?vue&type=script&lang=js"
export * from "./AuditUserDashboard.vue?vue&type=script&lang=js"

import "./AuditUserDashboard.vue?vue&type=style&index=0&id=96a283fe&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96a283fe"]])

export default __exports__